export default "__VITE_ASSET__Bwvfk5q8__"